module.exports = __webpack_public_path__ + "static/media/scan.fb4eab62.png";